import { idtype, linkTo, image } from "querypieces";
export default `
...on pageBuilder_clubMap_BlockType {
  ${idtype}
  heading
  richText
  ${linkTo}
  ${image}
}`;
